import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import EmptyContent from '@/views/Layout/EmptyContent.vue';
import apis from '@/apis/documentApi';
import { deepClone } from '@/utils/index';
import Document from './components/Document.vue';
import ScrollPagination from './ScrollPagination.vue';

var FuzzySearch = /*#__PURE__*/function (_Vue) {
  _inherits(FuzzySearch, _Vue);

  var _super = _createSuper(FuzzySearch);

  function FuzzySearch() {
    var _this;

    _classCallCheck(this, FuzzySearch);

    _this = _super.apply(this, arguments);
    _this.searchInput = '';
    _this.searchPageNo = 1;
    _this.searchCount = 0;
    _this.isResult = false;
    _this.historyList = [];
    _this.searchList = [];
    _this.historyName = "DocmentHistory".concat(_this.$store.getters.userInfo.userName);
    return _this;
  }

  _createClass(FuzzySearch, [{
    key: "onSearch",
    value: function onSearch() {
      var _this2 = this;

      if (this.searchInput.trim().length > 0) {
        apis.searchDocument({
          keyWord: this.searchInput,
          statusList: ['filed'],
          pageSize: 200,
          pageNo: this.searchPageNo
        }).then(function (res) {
          _this2.isResult = true;
          _this2.searchCount = res.data.total;
          _this2.searchList = res.data.list;

          _this2.setLocalStorage(res.data.list || []);
        }).catch(function (_) {});
      } else {
        this.searchInput = '';
        this.isResult = false;
        this.searchList = [];
        this.historyList = this.getLocalStorage();
      }
    } // 设置历史记录

  }, {
    key: "setLocalStorage",
    value: function setLocalStorage(list) {
      var newlist = deepClone(list);

      if (newlist.length < 10) {
        var historyList = this.getLocalStorage();
        var newSet = new Set();
        newlist.forEach(function (item) {
          newSet.add(item.caseId);
        });
        historyList.forEach(function (item) {
          if (!newSet.has(item.caseId)) {
            newlist.push(item);
          }
        });
      }

      localStorage.setItem(this.historyName, JSON.stringify({
        value: newlist.slice(0, 10)
      }));
    } // 获取历史记录

  }, {
    key: "getLocalStorage",
    value: function getLocalStorage() {
      var historyList = localStorage.getItem(this.historyName);

      if (historyList) {
        return JSON.parse(historyList).value || [];
      }

      return [];
    }
  }, {
    key: "onDeleteHistory",
    value: function onDeleteHistory() {
      var _this3 = this;

      this.$confirm('此操作将永久删除该历史记录, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function () {
        localStorage.removeItem(_this3.historyName);

        _this3.$message.success('删除成功');

        _this3.historyList = _this3.getLocalStorage();
      }).catch(function () {});
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.historyList = this.getLocalStorage();
    }
  }]);

  return FuzzySearch;
}(Vue);

FuzzySearch = __decorate([Component({
  components: {
    Document: Document,
    EmptyContent: EmptyContent,
    ScrollPagination: ScrollPagination
  }
})], FuzzySearch);
export default FuzzySearch;